import React, { useState } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import { homeFaqs } from '../../data/mock';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section
      id="faqs"
      className="py-16 sm:py-20 lg:py-24 relative overflow-hidden bg-slate-900"
      data-testid="faq-section"
    >
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full text-blue-400 text-sm font-medium mb-4">
            <HelpCircle className="w-4 h-4" aria-hidden="true" />
            FAQs
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            Frequently Asked <span className="bg-gradient-to-r from-blue-400 via-orange-400 to-emerald-400 bg-clip-text text-transparent">Questions</span>
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {homeFaqs.map((faq, i) => (
            <div
              key={i}
              className={`bg-slate-900/50 backdrop-blur-sm rounded-2xl border ${openIndex === i ? 'border-blue-500/40' : 'border-slate-800 hover:border-slate-700'} transition-colors`}
              data-testid={`faq-item-${i}`}
            >
              <button
                onClick={() => toggle(i)}
                aria-expanded={openIndex === i}
                className="w-full flex items-center justify-between p-5 sm:p-6 text-left"
                data-testid={`faq-toggle-${i}`}
              >
                <span className="text-white font-semibold text-base sm:text-lg pr-4">{faq.question}</span>
                <ChevronDown
                  className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180 text-blue-400' : 'text-slate-500'}`}
                  aria-hidden="true"
                />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-[500px]' : 'max-h-0'}`}>
                <div className="px-5 sm:px-6 pb-5 sm:pb-6">
                  <p className="text-slate-400 leading-relaxed text-sm sm:text-base">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
